var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/no-var-requires */
import { useState } from "react";
import { Box, Image, Text } from "native-base";
import { currentPregnancyWeek, differenceInDays, formatDate, formatDateTime, } from "@madmedical/utils";
import { PregnancyStatus } from "@madmedical/medical";
import { ApiFormWrapper } from "@madmedical/form";
import { useTranslation } from "@madmedical/i18n";
import { getInfantsNames } from "../../util/getInfantsNames";
import BabyWeight from "../../pics/Pregnancy/birth/BabyWeight";
import BabyBirth from "../../pics/Pregnancy/birth/BabyBirth";
import BabyLength from "../../pics/Pregnancy/birth/BabyLength";
import BabyCap from "../../pics/Pregnancy/birth/BabyCap";
import BirthBlockText from "../../molecules/Pregnancy/BirthBlockText";
import Paper from "../../atoms/Paper";
import ActionButton from "../../molecules/ActionButton";
import PregnancyDasboardBlock from "../../molecules/Pregnancy/PregnancyDasboardBlock";
import useResponsive from "../../util/useResponsive";
import PregnancyPlacentaImage from "../../molecules/Pregnancy/PregnancyPlacentaImage";
import PregnancyDashDatas from "../../molecules/Pregnancy/PregnancyDashDatas";
import PregnancyPieGraph from "../../molecules/Pregnancy/PregnancyPieGraph";
import PregnancyDataImage from "../../molecules/Pregnancy/PregnancyDataImage";
import PregnancyBodyImage from "../../molecules/Pregnancy/PregnancyBodyImage";
import PregnancySoonborn from "../../molecules/Pregnancy/PregnancySoonborn";
import IconButton from "../../atoms/IconButton";
import PregnancyDashboardAlert from "../../molecules/Pregnancy/PregnancyDashboardAlert";
import PregnancyWidgetsWrapper from "../../charts/PregnancyWidgetsWrapper";
import Modal from "../../molecules/Modal";
import BirthAbortionModal from "../../organisms/Patient/BirthAbortionModal";
import BirthCongratulationsModal from "../../organisms/Patient/BirthCongratulationsModal";
import useShowToast from "../../atoms/useShowToast";
import { getBabyStats } from "../../util/getBabyStats";
var ModalState;
(function (ModalState) {
    ModalState[ModalState["Closed"] = 0] = "Closed";
    ModalState[ModalState["Born"] = 1] = "Born";
    ModalState[ModalState["Miscarried"] = 2] = "Miscarried";
})(ModalState || (ModalState = {}));
const PregnancyDashboard = ({ isPrepaid = true, patientId, pregnancyData, goToLink, createEmpathy, createCongratulation, deletePregnancy, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { isSmallScreen } = useResponsive();
    const showToast = useShowToast();
    const { t } = useTranslation();
    const [modalState, setModalState] = useState(ModalState.Closed);
    const { bornAt, infants, expectedAt, status, miscarriedAt, miscarriedAmount, id: pregnancyId, startedAt, } = pregnancyData;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const bgImage = isSmallScreen
        ? require("../../pics/Pregnancy/img/dashboard_background_mobile.png")
        : require("../../pics/Pregnancy/img/dashboard_background.png");
    const pregnancyEndDay = 280;
    const pregnancyEndWeek = 40;
    const now = new Date();
    // now.setDate(now.getDate() - 3);
    const pregnancyDay = differenceInDays(new Date(startedAt), now);
    const pregnancyWeek = Math.floor(pregnancyDay / 7);
    const pregnancyWeekDay = Math.abs(pregnancyWeek * 7 - pregnancyDay);
    const pregnancyCurrentWeek = currentPregnancyWeek(new Date(startedAt), now);
    const percentage = (pregnancyDay / pregnancyEndDay) * 100;
    const timeRemaining = {
        weeks: pregnancyEndWeek - pregnancyCurrentWeek,
        days: pregnancyWeekDay === 0 ? 0 : 7 - pregnancyWeekDay,
    };
    const closeModal = () => {
        setModalState(ModalState.Closed);
    };
    const sendCongratulation = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        const bornAtDate = formData.bornAt
            ? new Date(formData.bornAt)
            : undefined;
        if (!bornAtDate) {
            showToast(t("fillInDateOfBirth") + "!", { variant: "error" });
            return;
        }
        try {
            const data = yield createCongratulation({
                patientId,
                bornAt: bornAtDate.toISOString(),
                infants: [
                    {
                        id: formData.id,
                        givenName: formData.givenName,
                        length: formData.length,
                        weight: formData.weight,
                        headCircumference: formData.headCircumference,
                    },
                ],
            });
            if (data) {
                closeModal();
            }
        }
        catch (e) {
            showToast(t("saveUnsuccessful."), { variant: "error" });
        }
    });
    const sendMiscarried = (formData) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = yield createEmpathy({
                patientId,
                miscarriedAt: formData.miscarriedAt,
                removePregnancyTracking: formData.removePregnancyTracking &&
                    formData.removePregnancyTracking === "yes"
                    ? true
                    : false,
                miscarriedAmount: formData.miscarriedAmount,
            });
            if (data) {
                closeModal();
            }
        }
        catch (e) {
            showToast(t("saveUnsuccessful."), { variant: "error" });
        }
    });
    const closePregnancy = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const data = yield deletePregnancy(pregnancyId);
            if (data) {
                closeModal();
                showToast(t("deleteSuccessfull"), { variant: "success" });
            }
        }
        catch (e) {
            showToast(t("saveUnsuccessful."), { variant: "error" });
        }
    });
    if (!isPrepaid) {
        return _jsx(PregnancyDashboardAlert, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, Object.assign({ width: "full", my: 2, minHeight: 250 }, { children: _jsxs(Paper, Object.assign({ backgroundColor: "#D0ECE5", 
                    // p={4}
                    // height="full"
                    position: "relative", overflow: "hidden" }, { children: [_jsx(Image, { source: bgImage, width: "full", height: "full", alt: "Pregnancy dashboard background", position: "absolute" }), _jsxs(Box, Object.assign({ flexDir: "row", mb: 2, justifyContent: "space-between", width: "full", p: 4 }, { children: [bornAt ? (_jsx(Box, Object.assign({ px: 2, flex: 1, justifyContent: "center" }, { children: _jsx(Text, Object.assign({ fontSize: "md", fontWeight: "medium", color: "#0E6369" }, { children: infants.length > 1
                                            ? `${getInfantsNames(infants)} ${t("pregnancy:births")}`
                                            : `${getInfantsNames(infants)} ${t("pregnancy:birth")}` })) }))) : (_jsxs(Box, Object.assign({ px: 2, flex: 1 }, { children: [_jsxs(Text, Object.assign({ fontSize: "md", fontWeight: "bold", color: "#0E6369" }, { children: [getInfantsNames(infants), " ", pregnancyWeek, " ", t("pregnancy:dateOfdateOfConception", {
                                                    weekDay: pregnancyWeekDay,
                                                })] })), _jsxs(Text, Object.assign({ color: "#0E6369", opacity: 0.75 }, { children: [t("pregnancy:estimatedDueDate"), " ", formatDate(new Date(expectedAt))] }))] }))), bornAt ? (_jsx(IconButton, { variant: "ghostLink", iconName: "close", size: "md", onPress: () => closePregnancy() })) : (_jsx(ActionButton, { iconName: "overflowMenuHorizontal", size: "lg", maxWidth: 240, actions: [
                                        {
                                            text: t("editData"),
                                            iconName: "edit",
                                            onPress: () => goToLink("onboarding"),
                                        },
                                        {
                                            text: t("pregnancy:pregnancyState"),
                                            iconName: "heart",
                                            submenu: [
                                                {
                                                    key: "1",
                                                    text: t("pregnancy:iAmPregnant"),
                                                    iconName: "checkmark",
                                                    iconColor: status ===
                                                        PregnancyStatus.NotBorn
                                                        ? "#1FBA9C"
                                                        : "transparent",
                                                    disabled: status ===
                                                        PregnancyStatus.NotBorn,
                                                },
                                                {
                                                    key: "2",
                                                    text: t("pregnancy:myBabyIsBorn"),
                                                    iconName: "checkmark",
                                                    iconColor: status ===
                                                        PregnancyStatus.Born
                                                        ? "#1FBA9C"
                                                        : "transparent",
                                                    disabled: status ===
                                                        PregnancyStatus.Born,
                                                    onPress: () => setModalState(ModalState.Born),
                                                },
                                                {
                                                    key: "3",
                                                    text: t("pregnancy:iHaveAproblem"),
                                                    iconName: "checkmark",
                                                    iconColor: "transparent",
                                                    subSubmenu: [
                                                        {
                                                            key: "31",
                                                            text: t("pregnancy:iMiscarried"),
                                                            onPress: () => setModalState(ModalState.Miscarried),
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ] }))] })), _jsxs(Box, Object.assign({ px: 4, pb: 4, width: "100%" }, { children: [pregnancyCurrentWeek >= pregnancyEndWeek - 1 &&
                                    !bornAt && (_jsx(PregnancySoonborn, { infants: infants, week: pregnancyCurrentWeek, openBirthModal: () => setModalState(ModalState.Born) })), bornAt ? (_jsxs(PregnancyWidgetsWrapper, { children: [_jsx(PregnancyDasboardBlock, { image: _jsx(BabyBirth, {}), text: _jsx(BirthBlockText, { label: t("pregnancy:timeOfBirth"), value: formatDateTime(new Date(bornAt)) }) }), _jsx(PregnancyDasboardBlock, { image: _jsx(BabyWeight, {}), text: _jsx(BirthBlockText, { label: t("pregnancy:babyWeight"), value: (_a = infants[0].weight) !== null && _a !== void 0 ? _a : "-", measure: "g" }) }), _jsx(PregnancyDasboardBlock, { image: _jsx(BabyLength, {}), text: _jsx(BirthBlockText, { label: t("pregnancy:babyLength"), value: (_b = infants[0].length) !== null && _b !== void 0 ? _b : "-", measure: "cm" }) }), _jsx(PregnancyDasboardBlock, { image: _jsx(BabyCap, {}), text: _jsx(BirthBlockText, { label: t("pregnancy:headCircumference"), value: (_c = infants[0].headCircumference) !== null && _c !== void 0 ? _c : "-", measure: "cm" }) })] })) : (_jsxs(PregnancyWidgetsWrapper, { children: [_jsx(PregnancyDasboardBlock, { image: _jsx(PregnancyDataImage, { week: pregnancyCurrentWeek }), text: _jsx(PregnancyDashDatas, { weight: getBabyStats(pregnancyCurrentWeek).weight, height: getBabyStats(pregnancyCurrentWeek).height }), link: "pregnancy_baby" }), _jsx(PregnancyDasboardBlock, { image: _jsx(PregnancyPieGraph, { percentage: percentage, weekNr: pregnancyCurrentWeek, trimesterNr: Math.ceil(percentage / 33) }), text: t("pregnancy:timeTillDelivery", {
                                                weeks: timeRemaining.weeks,
                                                days: timeRemaining.days,
                                            }), link: "pregnancy_body" }), _jsx(PregnancyDasboardBlock, { image: _jsx(PregnancyPlacentaImage, { week: Math.ceil(percentage / 6) }), text: _jsx(Text, Object.assign({ fontWeight: "medium" }, { children: t("pregnancy:placentaGrowth") })), link: "pregnancy_baby" }), _jsx(PregnancyDasboardBlock, { image: _jsx(PregnancyBodyImage, { week: Math.ceil(percentage / 12) }), text: _jsx(Text, Object.assign({ fontWeight: "medium" }, { children: t("pregnancy:bodyChanges") })), link: "pregnancy_body" })] }))] }))] })) })), modalState === ModalState.Miscarried && (_jsx(Modal, Object.assign({ open: modalState === ModalState.Miscarried, size: "sm", onClose: closeModal, hasCloseButton: false }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                        miscarriedAt: miscarriedAt !== null && miscarriedAt !== void 0 ? miscarriedAt : new Date().toISOString(),
                        removePregnancyTracking: "yes",
                        miscarriedAmount: miscarriedAmount !== null && miscarriedAmount !== void 0 ? miscarriedAmount : 1,
                    }, mutation: (data) => sendMiscarried(data), resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(BirthAbortionModal, { isSuccess: isSuccess, onClose: closeModal, onSubmitPress: submitForm })) })) }))), modalState === ModalState.Born && (_jsx(Modal, Object.assign({ open: modalState === ModalState.Born, size: "sm", onClose: closeModal }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                        id: infants[0].id,
                        givenName: (_d = infants[0].givenName) !== null && _d !== void 0 ? _d : "",
                        bornAt: bornAt !== null && bornAt !== void 0 ? bornAt : new Date().toISOString(),
                        length: (_e = infants[0].length) !== null && _e !== void 0 ? _e : 0,
                        weight: (_f = infants[0].weight) !== null && _f !== void 0 ? _f : 0,
                        headCircumference: (_g = infants[0].headCircumference) !== null && _g !== void 0 ? _g : 0,
                    }, mutation: (data) => sendCongratulation(data), resetOnSuccess: true }, { children: ({ submitForm, isSuccess }) => (_jsx(BirthCongratulationsModal, { isSuccess: isSuccess, onClose: closeModal, onSubmitPress: submitForm })) })) })))] }));
};
export default PregnancyDashboard;
